

































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ModalRecoveryCodeAlert extends Vue {
  @Prop({ type: Boolean, default: false })
  private showModal!: boolean;

  @Prop({ type: String, default: "warning" })
  private alertType!: string; // "warning" or "locked"

  private constants = {
    Dimensions: {
      MODAL_WIDTH: "550px",
      BUTTON_WIDTH: "120px",
      BUTTON_HEIGHT: "40px",
    },
  };

  get title(): string {
    return this.alertType === "locked"
      ? "รหัสกู้คืนของคุณถูกล็อก"
      : "คุณลืมรหัสกู้คืนใช่หรือไม่";
  }

  get reason(): string {
    if (this.alertType === "locked") {
      return `<span class="font-weight-bold">เนื่องจากคุณใส่รหัสครบแล้ว</span>`;
    }
    return "";
  }

  get description(): string {
    if (this.alertType === "locked") {
      return "กรุณาติดต่อ Support เบอร์ 1485 กด 3\nเพื่อยืนยันตัวตนในการเข้าสู่ระบบ";
    }
    return "กรุณาติดต่อ Support เบอร์ 1485 กด 3\nการพยายามเข้าสู่ระบบหลายครั้งด้วยรหัสที่ไม่ถูกต้อง\nอาจทำให้ไม่สามารถใช้รหัสกู้คืนได้อีก";
  }

  get fullDescription(): string {
    if (this.alertType === "warning") {
      // สำหรับ warning type รวม reason (ตัวหนา) กับ description ในบรรทัดเดียวกัน
      return `<span class="font-weight-bold">หากลืมรหัสกู้คืน</span> ${this.description}`;
    }
    return this.description;
  }

  public closeModal(): void {
    this.$emit("update:showModal", false);
    this.$emit("close");
  }
}
